import { IComponentOptions } from "angular";
import { PartTransactionItemController } from "../partTransactionItemController";

export const vsComponentName = "partTransactionDetailVoidPartLocationItem";

export const partTransactionDetailVoidPartLocationItemComponent: IComponentOptions =
  {
    bindings: {
      item: "<",
    },
    controller: PartTransactionItemController,
    controllerAs: "ctrl",
    template: require("!html-loader!./index.html").default,
  };
